export default __webpack_public_path__ + "static/media/BraceleT10.0433c482.jpg";